import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import MachinesTabRow from './MachinesTabRow';
import Arrays from '../../../utils/Arrays';
import { PsTable } from '../../table/PsTable';

class MachinesTabTable extends React.Component {

    buildHeader() {
        let checkedAll = false;
        if ( this.props.data || this.props.data.length > 0 ) {
            const nonSelectedElements = _.filter(this.props.data, element => !Arrays.contains(this.props.selectedIds, element.id));
            checkedAll = nonSelectedElements.length === 0;
        }
        return MachinesTabRow.renderHead('MACHINES_TAB_TABLE', this.props.showOutsource,
            this.props.selectedIds !== null ? {
                text: this.props.selectAllText,
                checked: checkedAll,
                onChecked: (checked) => this.props.actionSelectAll(this.props.data, checked),
            } : null);
    }

    render() {
        if ( !this.props.user || !this.props.user.roles || !this.props.user.roles[0] ) {
            return null;
        }
        if ( this.props.error ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{this.props.error}</h3>
                </section>
            );
        }
        if ( !this.props.data || this.props.data.length === 0 ) {
            return null;

        }

        return (
            <PsTable headings={this.buildHeader()}>
                {
                    _.map(this.props.data, object =>
                        <MachinesTabRow
                            key={object.id}
                            machine={object}
                            selectedIds={this.props.selectedIds}
                            actionSelectItem={this.props.actionSelectItem}
                            selectText={this.props.selectText}
                            showOutsource={this.props.showOutsource}
                            action={this.props.action}
                            actionText={this.props.actionText}
                        />,
                    )
                }
            </PsTable>
        );
    }

}

const mapStateToProps = state => {
    return ( {
        user: state.auth.user,
    } );
};

export default connect(mapStateToProps)(MachinesTabTable);

MachinesTabTable.propTypes = {
    data: PropTypes.any,
    error: PropTypes.string,

    selectedIds: PropTypes.array,
    actionSelectItem: PropTypes.func,
    actionSelectAll: PropTypes.func,
    selectText: PropTypes.string,
    selectAllText: PropTypes.string,
    showOutsource: PropTypes.bool,
    action: PropTypes.any,
    actionText: PropTypes.string,
};

MachinesTabTable.defaultProps = {
    selectedIds: null,
    showOutsource: false,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/tabs/machines/MachinesTabTable.jsx